import {
    Component,
    Input,
    HostBinding
} from '@angular/core';

@Component({
    selector: 'app-section-header',
    templateUrl: './section-header.component.pug',
    styleUrls: ['./section-header.component.less']
})
export class SectionHeaderComponent {
    @Input() set sticky(sticky) {
        this._sticky = sticky;
    }
    @HostBinding('class.--sticky') _sticky: boolean = false;

    constructor(
    ) {
    }
}
